export const countryConfigKE = {
  home: {
    skeleton: {
      banner: false,
      bubbles: false,
      featuredProducts: true,
      services: false,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  }
};
